import axios from 'axios';
import axiosInterceptor from './axiosInterceptor';
import {environment} from '../../environment';

const wampServer = environment.URL + '/api/b1/';
const axiosApi = axios.create({
    baseURL: wampServer,
});

// console.log("axiosApi",axiosApi);


axiosInterceptor.setupInterceptors(axiosApi);
export default axiosApi;
